<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="40vw"
    style="border-radius:15px"
  >
    <v-card style="border-radius:15px">
      <v-card-text
        ><div class="heading__3 my-4 text-xs-center">{{ message }}</div>
        <v-divider></v-divider
      ></v-card-text>

      <v-card-actions class="px-5 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          style="font-weight: bold;"
          flat
          color="error"
          @click="$emit('onClosed')"
          >cancel</v-btn
        >
        <v-btn
          class="elevation-0"
          style="border-radius:5px;color:black;font-weight: bold;"
          color="primary"
          @click="submit()"
          >continue</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      default() {
        return false;
      },
    },
    message: {
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.isLoading = false;
      }
    },
  },
  methods: {
    submit() {
      this.isLoading = true;
      let _this = this;
      this.$emit("onSaved", {
        done() {
          _this.isLoading = false;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
